import { Component, Input } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { EventsHubService, ExamMessage, EXAMMESSAGETYPE } from "src/app/services/eventshub.service";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PageObjectSound } from "src/app/models/pageobjectsound";
import { Exam } from "src/app/models/exam";

@Component({
  selector: "hkt-pageobjectsound",
  templateUrl: "./pageobjectsound.component.html",
  styleUrls: ["./pageobjectsound.component.scss"],
})
export class PageObjectSoundComponent {
  @Input("obj") obj: PageObjectSound;
  @Input("mode") mode: string;

  exam: Exam;
  examSubscription: Subscription;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
    private serverResourcesPathPipe: ServerResourcesPathPipe,
  ) {}

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
  }

  getSourceUrl(): string {
    if (this.obj.image == "") {
      let defaultImage = this.exam.style ? this.exam.style + "-speaker.png" : "speaker_blue.png";
      return "url('assets/" + defaultImage + "')";
    }

    let image = this.exam.library.getImage(this.obj.image);
    if (image == null) {
      return "url('assets/notimage.png')";
    }

    return this.serverResourcesPathPipe.transform(image.source, Config.SERVER_UPLOADFOLDER, "background_url");
  }

  onClick(): void {
    if (this.mode == "edit") {
      return;
    }

    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "PLAYSOUND(" + this.obj.sound + ")";
    this.eventsHubService.setExamMessage(msg);
  }
}
